import type {ResourceChangeRealtimeHandler} from "../../../shared/realtime/resource-change-realtime.types";
import type {output} from "zod";

import {MaterialFunctionRealtimeChange} from "@project/sdk/realtime";

import {materialFunctionKeys} from "../materialFunction-keys";

type MaterialFunctionRealtimeChangeEvent = output<typeof MaterialFunctionRealtimeChange>;

export const materialFunctionsRealtimeHandler: ResourceChangeRealtimeHandler<MaterialFunctionRealtimeChangeEvent> =
  {
    resource: "engineering.material-functions",
    queryKey: materialFunctionKeys.all,
    eventSchema: MaterialFunctionRealtimeChange,
    async handleEvent(event, queryClient) {
      if (event.change === "CREATED") {
        await queryClient.invalidateQueries({queryKey: materialFunctionKeys.lists()});

        return;
      }

      await queryClient.invalidateQueries({queryKey: materialFunctionKeys.all});
    },
  };
